import React from 'react'
import './styles.scss'

const DownloadLinks = ({ title, links }) => (
    <div className="download-links">
        <h2 className='download-links__title'>{title}</h2>
        {links.map(({ text, icon, href }) => (
            <a className="download-links__link button type_yellow size_l" href={href} key={href}>
                <img className="download-links__icon" src={icon} alt="Android" />
                <span className="download-links__text">{text}</span>
            </a>
        ))}
    </div>
)

export default DownloadLinks



// WEBPACK FOOTER //
// /app/apps/ms/src/components/DownloadLinks/index.js